import { withStyles } from '@material-ui/core';

import Breadcrumb from './component';
import styles from './styles';

export default withStyles(styles)(Breadcrumb);
